"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pHan = exports.pKatakana = exports.pHiragana = exports.NON_BREAKING_SPACE = exports.CURRENCY_SYMBOL = exports.CURRENCY_LANG_CODE = exports.TELEMETRY_DVS_NAME = exports.DVS_EDGE_URL = exports.DVS_CLIENT_NAMESPACE = exports.TELEMETRY_TOPIC_NAME = exports.DEFAULT_TAG = void 0;
//The default category tag for the captured texts
exports.DEFAULT_TAG = 'root';
//The default kafka topic metric name for telemetry 
exports.TELEMETRY_TOPIC_NAME = 'translation_telemetry';
//Configurations for DVS_CLIENT
exports.DVS_CLIENT_NAMESPACE = ['translation-service'];
exports.DVS_EDGE_URL = 'https://dynamic-values-edge-service.doordash.com';
exports.TELEMETRY_DVS_NAME = 'contentCaptureExperiment';
//constants for the currency prefixes
exports.CURRENCY_LANG_CODE = ['US', 'USD', 'A', 'AUD', 'AU', 'NZ', 'NZD', 'CA', 'CAD', 'CA', 'JP', 'JPY', 'EUR'];
exports.CURRENCY_SYMBOL = ['$', '￥', '¥', '€'];
//constants for Non-breaking space
exports.NON_BREAKING_SPACE = String.fromCharCode(160);
//constants for Japanese character with regex
exports.pHiragana = "[\\u3041-\\u3096\\u309D-\\u309F]|\\uD82C\\uDC01|\\uD83C\\uDE00";
exports.pKatakana = "[\\u30A1-\\u30FA\\u30FD-\\u30FF\\u31F0-\\u31FF\\u32D0-\\u32FE\\u3300-\\u3357\\uFF66-\\uFF6F\\uFF71-\\uFF9D]|\\uD82C\\uDC00";
exports.pHan = "[\\u2E80-\\u2E99\\u2E9B-\\u2EF3\\u2F00-\\u2FD5\\u3005\\u3007\\u3021-\\u3029\\u3038-\\u303B\\u3400-\\u4DB5\\u4E00-\\u9FD5\\uF900-\\uFA6D\\uFA70-\\uFAD9]|[\\uD840-\\uD868\\uD86A-\\uD86C\\uD86F-\\uD872][\\uDC00-\\uDFFF]|\\uD869[\\uDC00-\\uDED6\\uDF00-\\uDFFF]|\\uD86D[\\uDC00-\\uDF34\\uDF40-\\uDFFF]|\\uD86E[\\uDC00-\\uDC1D\\uDC20-\\uDFFF]|\\uD873[\\uDC00-\\uDEA1]|\\uD87E[\\uDC00-\\uDE1D]";
